module.exports = __webpack_public_path__ + "b5679ecc7dd2bbb699d4769c522c4ccd.svg";